<template>
    <DModal
        :title="__('customers.contracts.create_contract_tree.runtime')"
        is-confirm
        :show="showModal"
        is-medium
        @confirm="submitForm"
        @close="$emit('close-modal')"
    >
        <DCard
            padding
            class="runtime-form"
        >
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.runtime')"
                :is-required="true"
            >
                <DRow>
                    <DCol sm="5">
                        <DInput
                            id="contract_term"
                            v-model="form.contract_term"
                            type="number"
                            min="0"
                            max="127"
                            :placeholder="__('customers.contracts.create_contract_tree.contract_term')"
                        />
                        <p
                            v-if="errors.contract_term"
                            class="error-msg"
                        >
                            {{ errors.contract_term }}
                        </p>
                    </DCol>
                    <DCol sm="7">
                        <DSelect
                            id="contract_term_unit"
                            v-model="form.contract_term_unit"
                            :options="contractTermUnits"
                            :placeholder="__('customers.contracts.create_contract_tree.contract_term_unit')"
                        />
                        <p
                            v-if="errors.contract_term_unit"
                            class="error-msg"
                        >
                            {{ errors.contract_term_unit }}
                        </p>
                    </DCol>
                </DRow>
            </DFormRow>
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.notice_period')"
                :is-required="true"
            >
                <DRow>
                    <DCol sm="5">
                        <DInput
                            id="notice_period"
                            v-model="form.notice_period"
                            type="number"
                            min="0"
                            max="127"
                            :placeholder="__('customers.contracts.create_contract_tree.notice_period')"
                        />
                        <p
                            v-if="errors.notice_period"
                            class="error-msg"
                        >
                            {{ errors.notice_period }}
                        </p>
                    </DCol>
                    <DCol sm="7">
                        <DSelect
                            id="notice_period_units"
                            v-model="form.notice_period_unit"
                            :options="contractTermUnits"
                            :placeholder="__('customers.contracts.create_contract_tree.notice_period_unit')"
                        />
                        <p
                            v-if="errors.notice_period_unit"
                            class="error-msg"
                        >
                            {{ errors.notice_period_unit }}
                        </p>
                    </DCol>
                </DRow>
            </DFormRow>
        </DCard>
        <DCard
            padding
            class="runtime-form"
            :title="__('customers.contracts.create_contract_tree.after_that')"
        >
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.runtime_after')"
                :is-required="false"
            >
                <DRow>
                    <DCol sm="5">
                        <DInput
                            id="new_contract_term"
                            v-model="form.new_runtime_contract_term"
                            type="number"
                            min="0"
                            max="127"
                            :placeholder="__('customers.contracts.create_contract_tree.contract_term')"
                        />
                        <p
                            v-if="errors.new_runtime_contract_term"
                            class="error-msg"
                        >
                            {{ errors.new_runtime_contract_term }}
                        </p>
                    </DCol>
                    <DCol sm="7">
                        <DSelect
                            id="new_contract_term_unit"
                            v-model="form.new_runtime_contract_term_unit"
                            :options="contractTermUnits"
                            :placeholder="__('customers.contracts.create_contract_tree.contract_term_unit')"
                        />
                        <p
                            v-if="errors.new_runtime_contract_term_unit"
                            class="error-msg"
                        >
                            {{ errors.new_runtime_contract_term_unit }}
                        </p>
                    </DCol>
                </DRow>
            </DFormRow>
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.notice_period')"
                :is-required="false"
            >
                <DRow>
                    <DCol sm="5">
                        <DInput
                            id="new_notice_period"
                            v-model="form.new_runtime_notice_period"
                            type="number"
                            min="0"
                            max="127"
                            :placeholder="__('customers.contracts.create_contract_tree.notice_period_unit')"
                        />
                        <p
                            v-if="errors.new_runtime_notice_period"
                            class="error-msg"
                        >
                            {{ errors.new_runtime_notice_period }}
                        </p>
                    </DCol>
                    <DCol sm="7">
                        <DSelect
                            id="new_notice_period_unit"
                            v-model="form.new_runtime_notice_period_unit"
                            :options="contractTermUnits"
                            :placeholder="__('customers.contracts.create_contract_tree.notice_period_unit')"
                        />
                        <p
                            v-if="errors.new_runtime_notice_period_unit"
                            class="error-msg"
                        >
                            {{ errors.new_runtime_notice_period_unit }}
                        </p>
                    </DCol>
                </DRow>
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'RuntimeModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'submitRuntime'],
    data () {
        return {
            form: JSON.parse(JSON.stringify(this.contract)) // clone object
        }
    },
    methods: {
        submitForm () {
            this.$emit('submitRuntime', this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
.runtime-form {
    display: grid;
    grid-gap: 15px;
    border-radius: 0 !important;
    border-bottom: 0 !important;
}
.error-msg {
    padding-top: 3px;
    margin: 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
